import * as types from '@/shared/constants/mutationTypes';

const state = {
  openModalCount: 0,
};
const getters = {
  openModalCount: (state) => state.openModalCount,
};
const actions = {
  setOpenModalCount({ commit }, data) {
    commit(types.SET_OPEN_MODAL_COUNT, data);
  },
};
const mutations = {
  [types.SET_OPEN_MODAL_COUNT](state, data) {
    state.openModalCount = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};